// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18zF8","field":"styles_field__20a2z","fieldCol":"styles_fieldCol__26oXk","diffCol":"styles_diffCol__3VNdr","diff":"styles_diff__3gMs_"};